import { Component } from '@angular/core';

@Component({
  selector: 'via-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss'],
})
export class AuthHeaderComponent {}
